import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

function EmpresaLicencasPage({ empresa, usuario, onVoltar, onSair }) {
  const [licencas, setLicencas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({
    id: null,
    tipo: '',
    modelo: '',
    ativo: true,
    setor: '',
    servidor_impressora: false,
    app_nome: '',
    app_versao: '',
    plataforma: '',
    usuario_id: ''
  });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });

  const fetchLicencas = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/dispositivos?empresa_id=${empresa.id}`);
      const data = await res.json();
      setLicencas(Array.isArray(data) ? data : []);
    } catch (err) {
      setLicencas([]);
      setErro('Erro ao buscar licenças');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLicencas();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (lic = null) => {
    if (lic) {
      setForm({ ...lic });
      setEditando(true);
    } else {
      setForm({
        id: null,
        tipo: '',
        modelo: '',
        ativo: true,
        setor: '',
        servidor_impressora: false,
        app_nome: '',
        app_versao: '',
        plataforma: '',
        usuario_id: ''
      });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({
      id: null,
      tipo: '',
      modelo: '',
      ativo: true,
      setor: '',
      servidor_impressora: false,
      app_nome: '',
      app_versao: '',
      plataforma: '',
      usuario_id: ''
    });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(f => ({ ...f, [name]: checked }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.tipo || !form.modelo) {
      setErro('Preencha os campos obrigatórios!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/dispositivos/${form.id}` : `${API_URL}/dispositivos`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: form.tipo,
          modelo: form.modelo,
          setor: form.setor,
          ativo: form.ativo,
          servidor_impressora: form.servidor_impressora,
          app_nome: form.app_nome,
          app_versao: form.app_versao,
          plataforma: form.plataforma,
          usuario_id: form.usuario_id,
          empresa_id: empresa.id
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar licença');
      fecharModal();
      fetchLicencas();
    } catch (err) {
      setErro('Erro ao salvar licença');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/dispositivos/${confirmarExclusao.id}/desativar`, { method: 'PUT' });
      fetchLicencas();
    } catch {
      setErro('Erro ao desativar licença');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const licencasFiltradas = Array.isArray(licencas)
    ? licencas.filter(l =>
        (l.tipo || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
        (l.modelo || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
        (l.setor || '').toLowerCase().includes(pesquisa.toLowerCase())
      )
    : [];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Licenças / Dispositivos</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por tipo, modelo ou setor..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {licencasFiltradas.map(l => (
              <div key={l.id} className={`bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200 ${l.ativo === false ? 'opacity-50 grayscale' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{l.tipo}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(l)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(l.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Modelo:</b> {l.modelo}</div>
                <div className="text-gray-700 mb-1"><b>Setor:</b> {l.setor}</div>
                <div className="text-gray-700 mb-1"><b>Ativo:</b> {l.ativo ? 'Sim' : 'Não'}</div>
                <div className="text-gray-700 mb-1"><b>Servidor Impressora:</b> {l.servidor_impressora ? 'Sim' : 'Não'}</div>
                <div className="text-gray-700 mb-1"><b>App Nome:</b> {l.app_nome}</div>
                <div className="text-gray-700 mb-1"><b>App Versão:</b> {l.app_versao}</div>
                <div className="text-gray-700 mb-1"><b>Plataforma:</b> {l.plataforma}</div>
                <div className="text-gray-700 mb-1"><b>Usuário:</b> {l.usuario_id}</div>
              </div>
            ))}
            {licencasFiltradas.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhuma licença encontrada.</div>
            )}
          </div>
        )}
        {/* Modal de inclusão/edição */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">Editar Licença</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
                  <input name="tipo" value={form.tipo} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Modelo</label>
                  <input name="modelo" value={form.modelo} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Setor</label>
                  <input name="setor" value={form.setor} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={50} />
                </div>
                <div className="flex items-center gap-4">
                  <label className="flex items-center">
                    <input type="checkbox" name="ativo" checked={form.ativo} onChange={handleChange} className="mr-2" />
                    Ativo
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" name="servidor_impressora" checked={form.servidor_impressora} onChange={handleChange} className="mr-2" />
                    Servidor Impressora
                  </label>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">App Nome</label>
                  <input name="app_nome" value={form.app_nome} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">App Versão</label>
                  <input name="app_versao" value={form.app_versao} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Plataforma</label>
                  <input name="plataforma" value={form.plataforma} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Usuário</label>
                  <input name="usuario_id" value={form.usuario_id} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" readOnly />
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">Salvar</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <h3 className="text-xl font-bold text-blue-700 mb-4">Confirmar Exclusão</h3>
              <p>Tem certeza que deseja desativar esta licença?<br/>Ela não será excluída, apenas ficará inativa no sistema.</p>
              <div className="flex justify-end space-x-2 mt-6">
                <button type="button" onClick={cancelarRemocao} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button type="button" onClick={confirmarRemocao} className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition">Desativar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmpresaLicencasPage; 